export default "__VITE_ASSET__5zMMHSSu__"